import { Controller } from "@hotwired/stimulus"

// usage:
// // undo button will be inserted here as toast
// <fieldset>
//   <input name="_destroy"/>
//   <button role="button"
//     data-controller="nested-form--destroyable#mark"
//   >Mark for destruction</button>kusu
// </fieldset>
export default class extends Controller {
  static values = {
    i18nUndo: String
  }

  // sets '_destroy' input to '1' and hides fieldset
  mark (e) {
    const wrapper = e.target.closest("fieldset")

    // to override `d-flex`, `d-block`, etc.
    wrapper.classList.add("d-none")

    const input = wrapper.querySelector("input[name*='_destroy']")
    input.value = "1"

    // to trigger setting positioning, can be simple:
    //   <span class="d-none">🗑️↓</span>
     wrapper.insertAdjacentHTML('beforebegin', `
      <button
        data-controller="bs--toast"
        data-action="nested-form--destroyable#undo"
        type="button"
        class="btn btn-sm btn-info"
      >
        <span class="material-symbols-outlined">undo</span>
        ${this.i18nUndoValue}
      </button>
    `)
  }

  // sets '_destroy' input to '0' and shows fieldset
  undo (e) {
    const toast = e.target.closest("[data-controller=bs--toast]")
    const wrapper = toast.nextElementSibling

    toast.remove()
    wrapper.classList.remove("d-none")

    const input = wrapper.querySelector("input[name*='_destroy']")
    input.value = "0"
  }
}
